<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <h1 class="title">Land purchase contracts</h1>
      <app-cells>
        <app-button @click.native="onAddButtonClick">Create contract</app-button>
        <app-button @click.native="onClickMapButton" theme="info">Show on map</app-button>
      </app-cells>
      <table-lpc
        @showDeleteModal="onShowDeleteModal"
        @clickPagination="onClickPagination"
        @updateVillageFees="onUpdateVillageFees"
        :table-items="table_items"
        :table-preloader="table_preloader"
        :pagination="pagination"
      />
    </template>
    <modal
      name="create-form"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('create-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Create contract</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Main seller" label-for="main_seller" required>
              <app-input
                v-model="form.main_seller"
                :error="$v.form.main_seller.$error"
                id="main_seller"
                placeholder="Main seller"
                name="main_seller"
              />
              <template #error>
                <div v-if="$v.form.main_seller.$dirty && !$v.form.main_seller.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Second seller" label-for="second_seller">
              <app-input
                v-model="form.second_seller"
                id="second_seller"
                placeholder="Second seller"
                name="second_seller"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">Create</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="delete-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete contract
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this contract?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteItem" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteLandPurchaseContract,
  getLandPurchaseContractList,
  patchLandPurchaseContract,
  postLandPurchaseContract,
} from '@/http'
import {required} from 'vuelidate/lib/validators'
import TableLpc from '@/views/administrative/land-purchase-contract/tables/TableLPC'

export default {
  name: 'LandPurchaseContractList',
  components: {TableLpc},
  data() {
    return {
      is_loaded: false,
      table_preloader: false,
      table_items: [],
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {},
      item_to_delete: null,
    }
  },
  validations: {
    form: {
      main_seller: { required },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onDeleteItem() {
      this.$refs.delete.preload = true
      deleteLandPurchaseContract(this.item_to_delete)
        .finally(() => { this.$refs.delete.preload = false })
        .then(() => {
          this.fetchItems()
          this.$modal.hide('delete-modal')
          this.$notify({
            type: 'success',
            title: 'Contact deleted',
          })
        })
    },
    onShowDeleteModal(id) {
      this.item_to_delete = id
      this.$modal.show('delete-modal')
    },
    onClickMapButton() {
      this.$router.push({ name: 'land-purchase-contract-map' })
    },
    onUpdateVillageFees(row) {
      this.table_preloader = true
      patchLandPurchaseContract(row.id, { village_fees_paid: row.village_fees_paid })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
          this.fetchItems()
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    fetchItems() {
      this.table_preloader = true
      getLandPurchaseContractList({ page: this.pagination.page, page_size: 20 }).then(res => {
        this.table_items = res.data.results
        this.pagination.pages = res.data.pages
        this.pagination.count = res.data.count
        this.is_loaded = true
        this.table_preloader = false
      })
    },
    onCheckForm () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      postLandPurchaseContract(this.form)
        .finally(() => { this.$refs.submit.preload = false })
        .then(res => {
          this.$notify({
            type: 'success',
            title: 'Contract created',
          })
          this.$router.push({ name: 'land-purchase-contract-detail', params: { id: res.data.id } })
        })
    },
    onAddButtonClick() {
      this.form = {}
      this.$v.form.$reset()
      this.$modal.show('create-form')
    },
  }
}
</script>
